import * as React from "react";

import { BannerContainer } from "../../../components/BannerContainer";
import { MagicLinkBox } from "./styles";
import { LinkTargetType, TModuleWithImgProps } from "../../../services/playground";
import { TBannerItem } from "../../../services/banner";
import { transformAParam } from "utils/browser";

import { getSize } from "./utils";
import { Span } from "@sentry/types";

export interface TMagicItem {
	link: string;
	width: string;
	height: string;
	left: string;
	top: string;
}

export interface MagicBannerProps extends TModuleWithImgProps {
	banner: TBannerItem;
	linkItems: TMagicItem[];
	onClick?: (link?: string) => void;
	span?: Span;
}

const LitbMagicBanner = (props: MagicBannerProps) => {
	const { banner, positionId, linkItems, style = {}, className = "", placeholderBg } = props;

	React.useEffect(() => {
		props?.span?.finish();
	}, []);

	return (
		<BannerContainer
			banner={banner}
			id={positionId}
			className={className}
			placeholderBg={placeholderBg}
			keepSize={true}
			{...getSize(banner)}
			style={{
				...style,
			}}
		>
			{(linkItems || []).map((item: TMagicItem, i) => {
				const addCursor = item.link ? { cursor: "pointer" } : null;
				return (
					<MagicLinkBox
						key={i}
						{...transformAParam({
							isInApp: false,
							aTarget: LinkTargetType.Blank,
							link: item.link,
							onClick: props.onClick,
						})}
						style={{
							width: `${Math.min(100, +(item.width || 0))}%`,
							height: `${item.height}%`,
							top: `${item.top}%`,
							left: `${item.left}%`,
							...addCursor,
						}}
					/>
				);
			})}
		</BannerContainer>
	);
};

export default LitbMagicBanner;
